import React from "react";
import ProfilePic from "../Assets/john-doe-image.png";
import { AiFillStar } from "react-icons/ai";

const Testimonial = () => {
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Testimonial</p>
        <h1 className="primary-heading">What They Are Saying</h1>
        <p className="primary-text">
          A town hall different from bala blu, blue blu bulaba. broom broom
          broom brooooooooom. Bala blu blue blu bulaba.
        </p>
      </div>
      <div className="testimonial-section-bottom">
        <img src={ProfilePic} alt="" />
        <p>
          A town hall different from bala blu, blue blu bulaba. broom broom
          broom brooooooooom. Bala blu blue blu bulaba. The farmers will make
          more money. Your lunch will not be imported, cassava garri ewa and
          ehhh ehhhhnn. The farmer will make money, the dinner would be cassava,
          eba, ewa and everything.
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h2>T-pain Batman</h2>
      </div>
    </div>
  );
};

export default Testimonial;
